import React from 'react';
import useTextField from './useFormField';

const BASE_CLASS = 'text-field';

/**
 * @param {{
 *  field: Object<string, any>
 * }} arg React props
 * @returns {JSX.Element} ...
 */
export default function TextField({ field }) {
  const fieldProps = useTextField(field.id);
  return <label className={ `${BASE_CLASS}` }>
    <hgroup className={ `${BASE_CLASS}__label` }>{ field.label }</hgroup>
    <input
      type={ field.type }
      placeholder={ field.label }
      className={ `${BASE_CLASS}__input--${field.size}` }
      required={ field.isRequired }
      { ...fieldProps }
    />
  </label>;
}
